import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
import { r, rInset } from '../../../shared/lib/responsive';

const rankRowEnter = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Row = styled.li<{ $rank?: number }>`
  display: flex;
  align-items: center;
  ${r('gap', 10)}
  list-style: none;
  opacity: 0;
  animation: ${rankRowEnter} 0.4s ease forwards;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  ${(p) =>
    p.$rank === 2 &&
    css`
      animation-duration: 0.42s;
      animation-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
    `}

  ${(p) =>
    p.$rank === 3 &&
    css`
      animation-duration: 0.22s;
      animation-timing-function: ease-out;
    `}

  ${(p) =>
    p.$rank === 4 &&
    css`
      animation-duration: 0.38s;
      animation-timing-function: cubic-bezier(0.34, 1.1, 0.64, 1);
    `}
`;

export const RankIcon = styled.span`
  ${r('flex-basis', 25)}
  display: flex;
  align-items: center;
  justify-content: center;
  ${r('width', 25)}
  ${r('height', 24)}

  img {
    ${r('width', 25)}
    ${r('height', 24)}
    object-fit: contain;
  }
`;

export const RankNum = styled.span`
  font-family: var(--font-sans);
  font-weight: var(--font-weight-bold);
  font-size: var(--type-rank-number-size);
  line-height: 1;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-rank-num);
`;

export const Thumb = styled.span`
  flex: 0 0 var(--rank-thumb-size);
  width: var(--rank-thumb-size);
  height: var(--rank-thumb-size);
  border-radius: var(--rank-thumb-radius);
  overflow: hidden;
  background: var(--color-card-img-fallback);
`;

export const ThumbImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Name = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  font-family: var(--font-sans);
  font-weight: var(--font-weight-bold);
  font-size: var(--type-rank-menu-name-size);
  line-height: 1;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-on-dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Rate = styled.span<{ $tier: 'second' | 'third' | 'fourth' }>`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${r('min-width', 33)}
  ${rInset('padding', 2, 6)}
  border-radius: var(--radius-rate-badge);
  font-family: var(--font-sans);
  font-weight: var(--font-weight-bold);
  font-size: var(--type-vote-rate-size);
  line-height: 1;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-on-dark);

  ${(p) =>
    p.$tier === 'second' &&
    css`
      background: var(--color-rate-2nd);
    `}

  ${(p) =>
    p.$tier === 'third' &&
    css`
      background: var(--color-rate-3rd);
    `}

  ${(p) =>
    p.$tier === 'fourth' &&
    css`
      background: var(--color-rate-4th);
    `}
`;

export const Count = styled.span`
  flex: 0 0 auto;
  font-family: var(--font-sans);
  font-weight: var(--font-weight-bold);
  font-size: var(--type-rank-vote-count-size);
  line-height: 1;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-on-dark);
`;
